import { useContext, useEffect, useState } from 'react'
import styles from './RecoverPasswordModal.module.scss'
import { ModalFancy } from '../UI/Modals/ModalFancy/ModalFancy'
import { InputText } from '../UI/inputs/InputText/InputText'
import { ButtonByAdam } from '../UI/buttons/ButtonByAdam/ButtonByAdam'
import { DefaultHeader } from '../UI/headers/DefaultHeader/DefaultHeader'
import { GlobalNotificationContext } from '../../Context/GlobalNotification/GlobalNotificationProvider'
import { GlobalLoaderContext } from '../../Context/GlobalLoader/GlobalLoader'
import { NotificationType } from '../../Context/GlobalNotification/Types'
import { confirmNewPasswordVisitor } from '../../service/User/api'

interface Props {
  token: string
}

export const RecoverPasswordModal = ({ token }: Props): JSX.Element => {
  const [password, setPassword] = useState<string>('')
  const [confirmationPassword, setConfirmationPassword] = useState<string>('')

  useEffect(() => {
    const onClickEnterHandler = (event: KeyboardEvent) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        document.getElementById('recoverPasswordButton')?.click()
      }
    }
    document.addEventListener('keydown', onClickEnterHandler)
    return () => {
      document.removeEventListener('keydown', onClickEnterHandler)
    }
  }, [])

  const showLoader = useContext(GlobalLoaderContext)
  const showNotification = useContext(GlobalNotificationContext)

  const recoverPasswordHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    showLoader(true)
    confirmNewPasswordVisitor(token, password)
      .then((): void => {
        showNotification(
          NotificationType.INFO,
          'Hasło zostało zmienione poprawnie. Za moment zostaniesz wylogowany...'
        )
        setTimeout((): void => {
          showLoader(false)
          window.location.replace('/')
        }, 4000)
      })
      .catch((): void => showLoader(false))
  }

  return (
    <div className={styles.ModalContainer}>
      <ModalFancy>
        <>
          <DefaultHeader>Wpisz swoje nowe hasło</DefaultHeader>

          <form>
            <InputText
              label='Podaj nowe hasło'
              placeholder='Wpisz nowe hasło'
              onChangeHandler={(val: string): void => setPassword(val)}
              type='password'
              value={password}
              autoComplete='new-password'
              id='recover-password'
              name='recover-password'
            />

            <InputText
              label='Powtórz hasło'
              type='password'
              placeholder='Potwierdź hasło'
              onChangeHandler={(val: string): void =>
                setConfirmationPassword(val)
              }
              value={confirmationPassword}
              autoComplete='new-password'
              id='recover-password-confirm'
              name='recover-password-confirm'
            />

            {password.length > 0 &&
              confirmationPassword.length > 0 &&
              password !== confirmationPassword && (
                <div className='ui red message'>
                  Hasło nie zostało powtórzone poprawnie
                </div>
              )}

            <ButtonByAdam
              id='recoverPasswordButton'
              type='submit'
              disabled={
                password.length === 0 ||
                confirmationPassword.length === 0 ||
                password !== confirmationPassword
              }
              onClick={recoverPasswordHandler}
            >
              Potwierdź zmianę hasła
            </ButtonByAdam>
          </form>
        </>
      </ModalFancy>
    </div>
  )
}
